// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchUpsell-cls1_tQe","cls2":"SearchUpsell-cls2_xYA SearchUpsell-cls1_tQe"};